 export const newLargebarcodeLabel = (id: string, lotNumber: string) => `<?xml version="1.0" encoding="utf-8"?>
<DieCutLabel Version="8.0" Units="twips" MediaType="Default">
	<PaperOrientation>Landscape</PaperOrientation>
	<Id>Small30336</Id>
	<IsOutlined>false</IsOutlined>
	<PaperName>30336 1 in x 2-1/8 in</PaperName>
	<DrawCommands>
		<RoundRectangle X="0" Y="0" Width="1440" Height="3060" Rx="180" Ry="180" />
	</DrawCommands>
	<ObjectInfo>
		<BarcodeObject>
			<Name>123456</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>True</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<Text>${id}</Text>
			<Type>Code39</Type>
			<Size>Small</Size>
			<TextPosition>None</TextPosition>
			<TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			<CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			<TextEmbedding>None</TextEmbedding>
			<ECLevel>0</ECLevel>
			<HorizontalAlignment>Left</HorizontalAlignment>
			<QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
		</BarcodeObject>
		<Bounds X="151.454545454546" Y="645.792207792208" Width="1899.72727272727" Height="545.454545454546" />
	</ObjectInfo>
	<ObjectInfo>
		<BarcodeObject>
			<Name>BARCODE</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>False</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<Text>URL:portal.techreuse.com/public/${id}</Text>
			<Type>QRCode</Type>
			<Size>Medium</Size>
			<TextPosition>None</TextPosition>
			<TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			<CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			<TextEmbedding>None</TextEmbedding>
			<ECLevel>0</ECLevel>
			<HorizontalAlignment>Center</HorizontalAlignment>
			<QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
		</BarcodeObject>
		<Bounds X="2052.75324675324" Y="265.532467532468" Width="885.84415584416" Height="988.051948051948" />
	</ObjectInfo>
	<ObjectInfo>
		<TextObject>
			<Name>TEXT</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>False</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<HorizontalAlignment>Left</HorizontalAlignment>
			<VerticalAlignment>Top</VerticalAlignment>
			<TextFitMode>ShrinkToFit</TextFitMode>
			<UseFullFontHeight>True</UseFullFontHeight>
			<Verticalized>False</Verticalized>
			<StyledText>
				<Element>
					<String xml:space="preserve">Tech Tag:</String>
					<Attributes>
						<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					</Attributes>
				</Element>
			</StyledText>
		</TextObject>
		<Bounds X="332.233766233766" Y="131.805194805195" Width="833.753246753247" Height="202.597402597402" />
	</ObjectInfo>
	<ObjectInfo>
		<TextObject>
			<Name>TEXT_1</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>False</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<HorizontalAlignment>Left</HorizontalAlignment>
			<VerticalAlignment>Top</VerticalAlignment>
			<TextFitMode>ShrinkToFit</TextFitMode>
			<UseFullFontHeight>True</UseFullFontHeight>
			<Verticalized>False</Verticalized>
			<StyledText>
				<Element>
					<String xml:space="preserve">${id}</String>
					<Attributes>
						<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					</Attributes>
				</Element>
			</StyledText>
		</TextObject>
		<Bounds X="1173.98701298702" Y="131.805194805195" Width="652.974025974026" Height="202.597402597402" />
	</ObjectInfo>
	<ObjectInfo>
		<TextObject>
			<Name>TEXT__1</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>False</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<HorizontalAlignment>Left</HorizontalAlignment>
			<VerticalAlignment>Top</VerticalAlignment>
			<TextFitMode>ShrinkToFit</TextFitMode>
			<UseFullFontHeight>True</UseFullFontHeight>
			<Verticalized>False</Verticalized>
			<StyledText>
				<Element>
					<String xml:space="preserve">DPP</String>
					<Attributes>
						<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					</Attributes>
				</Element>
			</StyledText>
		</TextObject>
		<Bounds X="2146.25974025974" Y="131.805194805195" Width="534.532467532468" Height="134.025974025974" />
	</ObjectInfo>
	<ObjectInfo>
		<TextObject>
			<Name>TEXT_2</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>False</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<HorizontalAlignment>Left</HorizontalAlignment>
			<VerticalAlignment>Top</VerticalAlignment>
			<TextFitMode>ShrinkToFit</TextFitMode>
			<UseFullFontHeight>True</UseFullFontHeight>
			<Verticalized>False</Verticalized>
			<StyledText>
				<Element>
					<String xml:space="preserve">Lot:</String>
					<Attributes>
						<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					</Attributes>
				</Element>
			</StyledText>
		</TextObject>
		<Bounds X="382.103896103896" Y="374.415584415584" Width="310.116883116884" Height="158.961038961039" />
	</ObjectInfo>
	<ObjectInfo>
		<TextObject>
			<Name>TEXT__2</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>False</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<HorizontalAlignment>Center</HorizontalAlignment>
			<VerticalAlignment>Middle</VerticalAlignment>
			<TextFitMode>ShrinkToFit</TextFitMode>
			<UseFullFontHeight>True</UseFullFontHeight>
			<Verticalized>False</Verticalized>
			<StyledText>
				<Element>
					<String xml:space="preserve">${lotNumber}</String>
					<Attributes>
						<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					</Attributes>
				</Element>
			</StyledText>
		</TextObject>
		<Bounds X="725.350649350653" Y="362.64935064935" Width="1070.63636363636" Height="171.428571428571" />
	</ObjectInfo>
</DieCutLabel>`;

 export const otherLabel = (id, make, model, serial,base64) => `<?xml version="1.0" encoding="utf-8"?>
 <DieCutLabel Version="8.0" Units="twips">
	 <PaperOrientation>Landscape</PaperOrientation>
	 <Id>LargeShipping</Id>
	 <IsOutlined>false</IsOutlined>
	 <PaperName>30256 Shipping</PaperName>
	 <DrawCommands>
		 <RoundRectangle X="0" Y="0" Width="3331" Height="5715" Rx="270" Ry="270" />
	 </DrawCommands>
	 <ObjectInfo>
		 <TextObject>
			 <Name>titleText</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>ShrinkToFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${make} ${model}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="336" Y="145.817452357091" Width="3030.21063189569" Height="330.992978936793" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <ShapeObject Stroke="SolidLine">
			 <Name>SHAPE</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <ShapeType>HorizontalLine</ShapeType>
			 <LineWidth>15</LineWidth>
			 <LineAlignment>Center</LineAlignment>
			 <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
		 </ShapeObject>
		 <Bounds X="336" Y="595.548310275831" Width="5161.43068380409" Height="15" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <ImageObject>
			 <Name>logo</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <Image>${base64 ? base64 : defaultImg}</Image>
			 <ScaleMode>Uniform</ScaleMode>
			 <BorderWidth>0</BorderWidth>
			 <BorderColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <HorizontalAlignment>Center</HorizontalAlignment>
			 <VerticalAlignment>Center</VerticalAlignment>
		 </ImageObject>
		 <Bounds X="3476.81912669027" Y="72.2260111023001" Width="2076.58207612539" Height="480.843195725151" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>makeText</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${make}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="2066.17624149061" Y="760.988469997193" Width="1379.56687777542" Height="238.555667000982" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>screenSizeText</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>None</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${serial}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="2024.48214184821" Y="1659.72730821785" Width="1934.53171721874" Height="300" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <BarcodeObject>
			 <Name>qrCode</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <Text>URL:https://techspec.app/public/assets/70061</Text>
			 <Type>QRCode</Type>
			 <Size>Small</Size>
			 <TextPosition>None</TextPosition>
			 <TextFont Family="Tahoma" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			 <CheckSumFont Family="Tahoma" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			 <TextEmbedding>None</TextEmbedding>
			 <ECLevel>0</ECLevel>
			 <HorizontalAlignment>Center</HorizontalAlignment>
			 <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
		 </BarcodeObject>
		 <Bounds X="4359.06389486818" Y="1034.39503795179" Width="906.137985725532" Height="766.463124504356" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>TEXT_2</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">Model</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="336" Y="1192.73144587141" Width="1266.97597379286" Height="261.664994984935" />
	 </ObjectInfo>
	 <ObjectInfo>
	 <TextObject>
	 <Name>TEXT_5</Name>
	 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
	 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
	 <LinkedObjectName />
	 <Rotation>Rotation0</Rotation>
	 <IsMirrored>False</IsMirrored>
	 <IsVariable>False</IsVariable>
	 <GroupID>-1</GroupID>
	 <IsOutlined>False</IsOutlined>
	 <HorizontalAlignment>Left</HorizontalAlignment>
	 <VerticalAlignment>Top</VerticalAlignment>
	 <TextFitMode>AlwaysFit</TextFitMode>
	 <UseFullFontHeight>True</UseFullFontHeight>
	 <Verticalized>False</Verticalized>
	 <StyledText>
		 <Element>
			 <String xml:space="preserve">Serial</String>
			 <Attributes>
				 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
			 </Attributes>
		 </Element>
	 </StyledText>
 </TextObject>
		 <Bounds X="336" Y="1700.0534486897" Width="1373.61981720596" Height="238.555667000981" />
	 </ObjectInfo>
	 
	 
	 <ObjectInfo>
		 <TextObject>
			 <Name>modelText</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${model}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="2045.92576732018" Y="1178.20477547717" Width="1680.74709530449" Height="261.664994984934" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>TEXT__1</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">Make</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="336" Y="748.098418348468" Width="1266.97597379286" Height="261.664994984935" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>tt</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>ShrinkToFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${id}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="4489" Y="1875" Width="735" Height="285" />
	 </ObjectInfo>
 </DieCutLabel>
	 
	 `;
 
 export const barcodeLabel = (id: string, lotNumber: string) => `<?xml version="1.0" encoding="utf-8"?>
<DieCutLabel Version="8.0" Units="twips">
	<PaperOrientation>Landscape</PaperOrientation>
	<Id>ReturnAddress</Id>
	<IsOutlined>false</IsOutlined>
	<PaperName>30330 Return Address</PaperName>
	<DrawCommands>
		<RoundRectangle X="0" Y="0" Width="1080" Height="2880" Rx="180" Ry="180" />
	</DrawCommands>
	<ObjectInfo>
		<BarcodeObject>
			<Name>123456</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>True</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<Text>${id}</Text>
			<Type>Code39</Type>
			<Size>Small</Size>
			<TextPosition>None</TextPosition>
			<TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			<CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			<TextEmbedding>None</TextEmbedding>
			<ECLevel>0</ECLevel>
			<HorizontalAlignment>Left</HorizontalAlignment>
			<QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
		</BarcodeObject>
		<Bounds X="326" Y="570.987012987013" Width="1675.31168831169" Height="395.844155844156" />
	</ObjectInfo>
	<ObjectInfo>
		<BarcodeObject>
			<Name>BARCODE</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>False</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<Text>URL:portal.techreuse.com/public/${id}</Text>
			<Type>QRCode</Type>
			<Size>Medium</Size>
			<TextPosition>None</TextPosition>
			<TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			<CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			<TextEmbedding>None</TextEmbedding>
			<ECLevel>0</ECLevel>
			<HorizontalAlignment>Center</HorizontalAlignment>
			<QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
		</BarcodeObject>
		<Bounds X="2090.15584415584" Y="240.597402597403" Width="702.844155844162" Height="695.064935064935" />
	</ObjectInfo>
	<ObjectInfo>
		<TextObject>
			<Name>TEXT</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>False</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<HorizontalAlignment>Left</HorizontalAlignment>
			<VerticalAlignment>Top</VerticalAlignment>
			<TextFitMode>ShrinkToFit</TextFitMode>
			<UseFullFontHeight>True</UseFullFontHeight>
			<Verticalized>False</Verticalized>
			<StyledText>
				<Element>
					<String xml:space="preserve">Tech Tag:</String>
					<Attributes>
						<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					</Attributes>
				</Element>
			</StyledText>
		</TextObject>
		<Bounds X="326" Y="57" Width="833.753246753247" Height="202.597402597402" />
	</ObjectInfo>
	<ObjectInfo>
		<TextObject>
			<Name>TEXT_1</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>False</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<HorizontalAlignment>Left</HorizontalAlignment>
			<VerticalAlignment>Top</VerticalAlignment>
			<TextFitMode>ShrinkToFit</TextFitMode>
			<UseFullFontHeight>True</UseFullFontHeight>
			<Verticalized>False</Verticalized>
			<StyledText>
				<Element>
					<String xml:space="preserve">${id}</String>
					<Attributes>
						<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					</Attributes>
				</Element>
			</StyledText>
		</TextObject>
		<Bounds X="1167.75324675325" Y="57" Width="652.974025974026" Height="202.597402597402" />
	</ObjectInfo>
	<ObjectInfo>
		<TextObject>
			<Name>TEXT__1</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>False</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<HorizontalAlignment>Left</HorizontalAlignment>
			<VerticalAlignment>Top</VerticalAlignment>
			<TextFitMode>ShrinkToFit</TextFitMode>
			<UseFullFontHeight>True</UseFullFontHeight>
			<Verticalized>False</Verticalized>
			<StyledText>
				<Element>
					<String xml:space="preserve">DPP</String>
					<Attributes>
						<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					</Attributes>
				</Element>
			</StyledText>
		</TextObject>
		<Bounds X="2140.02597402597" Y="57" Width="534.532467532468" Height="134.025974025974" />
	</ObjectInfo>
	<ObjectInfo>
		<TextObject>
			<Name>TEXT_2</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>False</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<HorizontalAlignment>Left</HorizontalAlignment>
			<VerticalAlignment>Top</VerticalAlignment>
			<TextFitMode>ShrinkToFit</TextFitMode>
			<UseFullFontHeight>True</UseFullFontHeight>
			<Verticalized>False</Verticalized>
			<StyledText>
				<Element>
					<String xml:space="preserve">Lot:</String>
					<Attributes>
						<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					</Attributes>
				</Element>
			</StyledText>
		</TextObject>
		<Bounds X="375.87012987013" Y="299.610389610389" Width="310.116883116884" Height="158.961038961039" />
	</ObjectInfo>
	<ObjectInfo>
		<TextObject>
			<Name>TEXT__2</Name>
			<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			<LinkedObjectName />
			<Rotation>Rotation0</Rotation>
			<IsMirrored>False</IsMirrored>
			<IsVariable>False</IsVariable>
			<GroupID>-1</GroupID>
			<IsOutlined>False</IsOutlined>
			<HorizontalAlignment>Center</HorizontalAlignment>
			<VerticalAlignment>Middle</VerticalAlignment>
			<TextFitMode>ShrinkToFit</TextFitMode>
			<UseFullFontHeight>True</UseFullFontHeight>
			<Verticalized>False</Verticalized>
			<StyledText>
				<Element>
					<String xml:space="preserve">${lotNumber}</String>
					<Attributes>
						<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					</Attributes>
				</Element>
			</StyledText>
		</TextObject>
		<Bounds X="719.116883116887" Y="287.844155844155" Width="322.584415584415" Height="171.428571428571" />
	</ObjectInfo>
</DieCutLabel>`;
 
 
	 export const specLabel = (id,cpu, ram, hdd, serial,make,model,base64) => `<?xml version="1.0" encoding="utf-8"?>
	 <DieCutLabel Version="8.0" Units="twips">
		 <PaperOrientation>Landscape</PaperOrientation>
		 <Id>LargeShipping</Id>
		 <IsOutlined>false</IsOutlined>
		 <PaperName>30256 Shipping</PaperName>
		 <DrawCommands>
			 <RoundRectangle X="0" Y="0" Width="3331" Height="5715" Rx="270" Ry="270" />
		 </DrawCommands>
		 <ObjectInfo>
			 <TextObject>
				 <Name>titleText</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>False</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <HorizontalAlignment>Left</HorizontalAlignment>
				 <VerticalAlignment>Top</VerticalAlignment>
				 <TextFitMode>ShrinkToFit</TextFitMode>
				 <UseFullFontHeight>True</UseFullFontHeight>
				 <Verticalized>False</Verticalized>
				 <StyledText>
					 <Element>
						 <String xml:space="preserve">${make} ${model}</String>
						 <Attributes>
							 <Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
							 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
						 </Attributes>
					 </Element>
				 </StyledText>
			 </TextObject>
			 <Bounds X="336" Y="145.817452357091" Width="3030.21063189569" Height="330.992978936793" />
		 </ObjectInfo>
		 <ObjectInfo>
			 <ShapeObject Stroke="SolidLine">
				 <Name>SHAPE</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>False</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <ShapeType>HorizontalLine</ShapeType>
				 <LineWidth>15</LineWidth>
				 <LineAlignment>Center</LineAlignment>
				 <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
			 </ShapeObject>
			 <Bounds X="336" Y="595.548310275831" Width="5161.43068380409" Height="15" />
		 </ObjectInfo>
		 <ObjectInfo>
			 <BarcodeObject>
				 <Name>BARCODE</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>True</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <Text>${id}</Text>
				 <Type>Code39</Type>
				 <Size>Medium</Size>
				 <TextPosition>Bottom</TextPosition>
				 <TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
				 <CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
				 <TextEmbedding>None</TextEmbedding>
				 <ECLevel>0</ECLevel>
				 <HorizontalAlignment>Center</HorizontalAlignment>
				 <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
			 </BarcodeObject>
			 <Bounds X="336" Y="2276.92726389477" Width="3030.07673060884" Height="586.241932084698" />
		 </ObjectInfo>
		 <ObjectInfo>
			 <TextObject>
				 <Name>TEXT_2</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>False</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <HorizontalAlignment>Left</HorizontalAlignment>
				 <VerticalAlignment>Top</VerticalAlignment>
				 <TextFitMode>None</TextFitMode>
				 <UseFullFontHeight>True</UseFullFontHeight>
				 <Verticalized>False</Verticalized>
				 <StyledText>
					 <Element>
						 <String xml:space="preserve">Memory</String>
						 <Attributes>
							 <Font Family="Tahoma" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False" />
							 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
						 </Attributes>
					 </Element>
				 </StyledText>
			 </TextObject>
			 <Bounds X="389.921765295891" Y="1027.82347041129" Width="832.042100326865" Height="261.664994984935" />
		 </ObjectInfo>
		 <ObjectInfo>
			 <TextObject>
				 <Name>TEXT_3</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>False</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <HorizontalAlignment>Left</HorizontalAlignment>
				 <VerticalAlignment>Top</VerticalAlignment>
				 <TextFitMode>None</TextFitMode>
				 <UseFullFontHeight>True</UseFullFontHeight>
				 <Verticalized>False</Verticalized>
				 <StyledText>
					 <Element>
						 <String xml:space="preserve">Storage</String>
						 <Attributes>
							 <Font Family="Tahoma" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False" />
							 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
						 </Attributes>
					 </Element>
				 </StyledText>
			 </TextObject>
			 <Bounds X="386.070210631898" Y="1351.35406218663" Width="842.920589321782" Height="288.62587763288" />
		 </ObjectInfo>
		 <ObjectInfo>
			 <ImageObject>
				 <Name>logo</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>False</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <Image>${base64 ? base64 : defaultImg}</Image>
				 <ScaleMode>Uniform</ScaleMode>
				 <BorderWidth>0</BorderWidth>
				 <BorderColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <HorizontalAlignment>Center</HorizontalAlignment>
				 <VerticalAlignment>Center</VerticalAlignment>
			 </ImageObject>
			 <Bounds X="3476.81912669027" Y="72.2260111023001" Width="2076.58207612539" Height="480.843195725151" />
		 </ObjectInfo>
		 <ObjectInfo>
			 <TextObject>
				 <Name>TEXT_5</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>False</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <HorizontalAlignment>Left</HorizontalAlignment>
				 <VerticalAlignment>Top</VerticalAlignment>
				 <TextFitMode>None</TextFitMode>
				 <UseFullFontHeight>True</UseFullFontHeight>
				 <Verticalized>False</Verticalized>
				 <StyledText>
					 <Element>
						 <String xml:space="preserve">Serial  </String>
						 <Attributes>
							 <Font Family="Arial" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False" />
							 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
						 </Attributes>
					 </Element>
				 </StyledText>
			 </TextObject>
			 <Bounds X="380.918489011889" Y="1688.67816773088" Width="645.178008664711" Height="238.555667000981" />
		 </ObjectInfo>
		 <ObjectInfo>
			 <TextObject>
				 <Name>cpuData</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>False</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <HorizontalAlignment>Left</HorizontalAlignment>
				 <VerticalAlignment>Top</VerticalAlignment>
				 <TextFitMode>AlwaysFit</TextFitMode>
				 <UseFullFontHeight>True</UseFullFontHeight>
				 <Verticalized>False</Verticalized>
				 <StyledText>
					 <Element>
						 <String xml:space="preserve">${cpu}</String>
						 <Attributes>
							 <Font Family="Tahoma" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False" />
							 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
						 </Attributes>
					 </Element>
				 </StyledText>
			 </TextObject>
			 <Bounds X="1393.52611363044" Y="708.144433299943" Width="4065.80540988554" Height="238.555667000982" />
		 </ObjectInfo>
		 <ObjectInfo>
			 <TextObject>
				 <Name>ramText</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>False</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <HorizontalAlignment>Left</HorizontalAlignment>
				 <VerticalAlignment>Top</VerticalAlignment>
				 <TextFitMode>None</TextFitMode>
				 <UseFullFontHeight>True</UseFullFontHeight>
				 <Verticalized>False</Verticalized>
				 <StyledText>
					 <Element>
						 <String xml:space="preserve">${ram}GB</String>
						 <Attributes>
							 <Font Family="Tahoma" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False" />
							 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
						 </Attributes>
					 </Element>
				 </StyledText>
			 </TextObject>
			 <Bounds X="1411.7973269532" Y="1046.09468373405" Width="2185.33901714413" Height="261.664994984934" />
		 </ObjectInfo>
		 <ObjectInfo>
			 <TextObject>
				 <Name>serialText</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>False</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <HorizontalAlignment>Left</HorizontalAlignment>
				 <VerticalAlignment>Top</VerticalAlignment>
				 <TextFitMode>None</TextFitMode>
				 <UseFullFontHeight>True</UseFullFontHeight>
				 <Verticalized>False</Verticalized>
				 <StyledText>
					 <Element>
						 <String xml:space="preserve">${serial}</String>
						 <Attributes>
							 <Font Family="Arial" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False" />
							 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
						 </Attributes>
					 </Element>
				 </StyledText>
			 </TextObject>
			 <Bounds X="1399.46074544021" Y="1696.89135606669" Width="2791.46667765227" Height="235.812846946851" />
		 </ObjectInfo>
		 <ObjectInfo>
			 <TextObject>
				 <Name>hddText</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>False</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <HorizontalAlignment>Left</HorizontalAlignment>
				 <VerticalAlignment>Top</VerticalAlignment>
				 <TextFitMode>None</TextFitMode>
				 <UseFullFontHeight>True</UseFullFontHeight>
				 <Verticalized>False</Verticalized>
				 <StyledText>
					 <Element>
						 <String xml:space="preserve">${hdd}GB</String>
						 <Attributes>
							 <Font Family="Arial" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False" />
							 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
						 </Attributes>
					 </Element>
				 </StyledText>
			 </TextObject>
			 <Bounds X="1407.96838038031" Y="1369.08510638298" Width="2790.33059723782" Height="300" />
		 </ObjectInfo>
		 <ObjectInfo>
			 <TextObject>
				 <Name>TEXT__1</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>False</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <HorizontalAlignment>Left</HorizontalAlignment>
				 <VerticalAlignment>Top</VerticalAlignment>
				 <TextFitMode>None</TextFitMode>
				 <UseFullFontHeight>True</UseFullFontHeight>
				 <Verticalized>False</Verticalized>
				 <StyledText>
					 <Element>
						 <String xml:space="preserve">CPU</String>
						 <Attributes>
							 <Font Family="Tahoma" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False" />
							 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
						 </Attributes>
					 </Element>
				 </StyledText>
			 </TextObject>
			 <Bounds X="389.921765295891" Y="697.82347041129" Width="738.535606820371" Height="261.664994984935" />
		 </ObjectInfo>
		 <ObjectInfo>
			 <BarcodeObject>
				 <Name>qrCode</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>False</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <Text>URL:https://portal.techreuse.com/public/${id}</Text>
				 <Type>QRCode</Type>
				 <Size>Small</Size>
				 <TextPosition>None</TextPosition>
				 <TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
				 <CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
				 <TextEmbedding>None</TextEmbedding>
				 <ECLevel>0</ECLevel>
				 <HorizontalAlignment>Center</HorizontalAlignment>
				 <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
			 </BarcodeObject>
			 <Bounds X="4605.88207668636" Y="1067.70672626348" Width="666.137985725532" Height="616.463124504356" />
		 </ObjectInfo>
		 <ObjectInfo>
			 <TextObject>
				 <Name>TEXT</Name>
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
				 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
				 <LinkedObjectName />
				 <Rotation>Rotation0</Rotation>
				 <IsMirrored>False</IsMirrored>
				 <IsVariable>False</IsVariable>
				 <GroupID>-1</GroupID>
				 <IsOutlined>False</IsOutlined>
				 <HorizontalAlignment>Left</HorizontalAlignment>
				 <VerticalAlignment>Top</VerticalAlignment>
				 <TextFitMode>ShrinkToFit</TextFitMode>
				 <UseFullFontHeight>True</UseFullFontHeight>
				 <Verticalized>False</Verticalized>
				 <StyledText>
					 <Element>
						 <String xml:space="preserve">Digital Passport</String>
						 <Attributes>
							 <Font Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
							 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
						 </Attributes>
					 </Element>
				 </StyledText>
			 </TextObject>
			 <Bounds X="4296.33766233766" Y="1763.37662337662" Width="1296.62337662338" Height="246.233766233766" />
		 </ObjectInfo>
	 </DieCutLabel>`;
 
 
	 export const monitorLabel = (id, make, model, screensize, serial,base64) => `<?xml version="1.0" encoding="utf-8"?>
 <DieCutLabel Version="8.0" Units="twips">
	 <PaperOrientation>Landscape</PaperOrientation>
	 <Id>LargeShipping</Id>
	 <IsOutlined>false</IsOutlined>
	 <PaperName>30256 Shipping</PaperName>
	 <DrawCommands>
		 <RoundRectangle X="0" Y="0" Width="3331" Height="5715" Rx="270" Ry="270" />
	 </DrawCommands>
	 <ObjectInfo>
		 <TextObject>
			 <Name>titleText</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>ShrinkToFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${make} ${model}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="336" Y="145.817452357091" Width="3030.21063189569" Height="330.992978936793" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <ShapeObject Stroke="SolidLine">
			 <Name>SHAPE</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <ShapeType>HorizontalLine</ShapeType>
			 <LineWidth>15</LineWidth>
			 <LineAlignment>Center</LineAlignment>
			 <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
		 </ShapeObject>
		 <Bounds X="336" Y="595.548310275831" Width="5161.43068380409" Height="15" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <ImageObject>
			 <Name>logo</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <Image>${base64 ? base64 : defaultImg}</Image>
			 <ScaleMode>Uniform</ScaleMode>
			 <BorderWidth>0</BorderWidth>
			 <BorderColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <HorizontalAlignment>Center</HorizontalAlignment>
			 <VerticalAlignment>Center</VerticalAlignment>
		 </ImageObject>
		 <Bounds X="3476.81912669027" Y="72.2260111023001" Width="2076.58207612539" Height="480.843195725151" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>makeText</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${make}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="2066.17624149061" Y="760.988469997193" Width="1379.56687777542" Height="238.555667000982" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>screenSizeText</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>None</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${screensize}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="2024.48214184821" Y="1659.72730821785" Width="1934.53171721874" Height="300" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <BarcodeObject>
			 <Name>qrCode</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <Text>URL:https://techspec.app/public/assets/70061</Text>
			 <Type>QRCode</Type>
			 <Size>Small</Size>
			 <TextPosition>None</TextPosition>
			 <TextFont Family="Tahoma" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			 <CheckSumFont Family="Tahoma" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			 <TextEmbedding>None</TextEmbedding>
			 <ECLevel>0</ECLevel>
			 <HorizontalAlignment>Center</HorizontalAlignment>
			 <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
		 </BarcodeObject>
		 <Bounds X="4359.06389486818" Y="1034.39503795179" Width="906.137985725532" Height="766.463124504356" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>TEXT_2</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">Model</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="336" Y="1192.73144587141" Width="1266.97597379286" Height="261.664994984935" />
	 </ObjectInfo>
	 <ObjectInfo>
	 <TextObject>
	 <Name>TEXT_5</Name>
	 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
	 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
	 <LinkedObjectName />
	 <Rotation>Rotation0</Rotation>
	 <IsMirrored>False</IsMirrored>
	 <IsVariable>False</IsVariable>
	 <GroupID>-1</GroupID>
	 <IsOutlined>False</IsOutlined>
	 <HorizontalAlignment>Left</HorizontalAlignment>
	 <VerticalAlignment>Top</VerticalAlignment>
	 <TextFitMode>AlwaysFit</TextFitMode>
	 <UseFullFontHeight>True</UseFullFontHeight>
	 <Verticalized>False</Verticalized>
	 <StyledText>
		 <Element>
			 <String xml:space="preserve">Screen Size</String>
			 <Attributes>
				 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
				 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
			 </Attributes>
		 </Element>
	 </StyledText>
 </TextObject>
		 <Bounds X="336" Y="1700.0534486897" Width="1373.61981720596" Height="238.555667000981" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>TEXT_5</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">Serial #</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="336" Y="2112.72724748548" Width="1338.32706144679" Height="238.555667000981" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>serialText</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${serial}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="2017.4333913568" Y="2119.64364964468" Width="1436.36547222178" Height="235.812846946851" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>modelText</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${model}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="2045.92576732018" Y="1178.20477547717" Width="1680.74709530449" Height="261.664994984934" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>TEXT__1</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">Make</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="336" Y="748.098418348468" Width="1266.97597379286" Height="261.664994984935" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>tt</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>ShrinkToFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${id}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="4489" Y="1875" Width="735" Height="285" />
	 </ObjectInfo>
 </DieCutLabel>
	 
	 `;
 
	 
	 export const mobileLabel = (id, make, model, storage, carrier , serial,base64) => `<?xml version="1.0" encoding="utf-8"?>
 <DieCutLabel Version="8.0" Units="twips">
	 <PaperOrientation>Landscape</PaperOrientation>
	 <Id>LargeShipping</Id>
	 <IsOutlined>false</IsOutlined>
	 <PaperName>30256 Shipping</PaperName>
	 <DrawCommands>
		 <RoundRectangle X="0" Y="0" Width="3331" Height="5715" Rx="270" Ry="270" />
	 </DrawCommands>
	 <ObjectInfo>
		 <TextObject>
			 <Name>titleText</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>ShrinkToFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${model}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="336" Y="145.817452357091" Width="3030.21063189569" Height="330.992978936793" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <ShapeObject Stroke="SolidLine">
			 <Name>SHAPE</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <ShapeType>HorizontalLine</ShapeType>
			 <LineWidth>15</LineWidth>
			 <LineAlignment>Center</LineAlignment>
			 <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
		 </ShapeObject>
		 <Bounds X="336" Y="595.548310275831" Width="5161.43068380409" Height="15" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <ImageObject>
			 <Name>logo</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <Image>${base64 ? base64 : defaultImg}</Image>
			 <ScaleMode>Uniform</ScaleMode>
			 <BorderWidth>0</BorderWidth>
			 <BorderColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <HorizontalAlignment>Center</HorizontalAlignment>
			 <VerticalAlignment>Center</VerticalAlignment>
		 </ImageObject>
		 <Bounds X="3476.81912669027" Y="72.2260111023001" Width="2076.58207612539" Height="480.843195725151" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>makeText</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${make}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="2035.00741032178" Y="779.689768698492" Width="1379.56687777542" Height="238.555667000982" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <BarcodeObject>
			 <Name>qrCode</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <Text>URL:https://techspec.app/public/assets/70061</Text>
			 <Type>QRCode</Type>
			 <Size>Small</Size>
			 <TextPosition>None</TextPosition>
			 <TextFont Family="Tahoma" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			 <CheckSumFont Family="Tahoma" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
			 <TextEmbedding>None</TextEmbedding>
			 <ECLevel>0</ECLevel>
			 <HorizontalAlignment>Center</HorizontalAlignment>
			 <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
		 </BarcodeObject>
		 <Bounds X="4359.06389486818" Y="1034.39503795179" Width="906.137985725532" Height="766.463124504356" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>TEXT_2</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">Model</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="336" Y="1192.73144587141" Width="1266.97597379286" Height="261.664994984935" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>TEXT_5</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">Serial #</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="336" Y="1700.0534486897" Width="1373.61981720596" Height="238.555667000981" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>TEXT_5</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">Storage</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="336" Y="2112.72724748548" Width="1338.32706144679" Height="238.555667000981" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>serialText</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${storage}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="2017.4333913568" Y="2119.64364964468" Width="1436.36547222178" Height="235.812846946851" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>modelText</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">iphone 8</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="2033.45823485265" Y="1196.90607417847" Width="1680.74709530449" Height="261.664994984934" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>TEXT__1</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">Make</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="336" Y="748.098418348468" Width="1266.97597379286" Height="261.664994984935" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>tt</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>ShrinkToFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${id}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="4489" Y="1875" Width="735" Height="285" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>TEXT__2</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">Carrier</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="336" Y="2599.15581891405" Width="1338.32706144679" Height="238.555667000981" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>${carrier}</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">carrierText</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="2017.6281965516" Y="2599.83845483948" Width="1436.36547222178" Height="235.812846946851" />
	 </ObjectInfo>
	 <ObjectInfo>
		 <TextObject>
			 <Name>modelText_1</Name>
			 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
			 <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
			 <LinkedObjectName />
			 <Rotation>Rotation0</Rotation>
			 <IsMirrored>False</IsMirrored>
			 <IsVariable>False</IsVariable>
			 <GroupID>-1</GroupID>
			 <IsOutlined>False</IsOutlined>
			 <HorizontalAlignment>Left</HorizontalAlignment>
			 <VerticalAlignment>Top</VerticalAlignment>
			 <TextFitMode>AlwaysFit</TextFitMode>
			 <UseFullFontHeight>True</UseFullFontHeight>
			 <Verticalized>False</Verticalized>
			 <StyledText>
				 <Element>
					 <String xml:space="preserve">${serial}</String>
					 <Attributes>
						 <Font Family="Tahoma" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
						 <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
					 </Attributes>
				 </Element>
			 </StyledText>
		 </TextObject>
		 <Bounds X="2027.41927381369" Y="1689.56841184081" Width="1680.74709530449" Height="236.729930049869" />
	 </ObjectInfo>
 </DieCutLabel>
	 `;
 
	 const defaultImg = "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";